import client from '@/api/client';

/** Shape returned by POST /auth/sso/edc — identical to the password-login response. */
export interface EdcSsoExchangeResponse {
  accessToken: string;
  refreshToken: string;
  user: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    role: string;
    permissions: string[];
    studyAssignments: string[];
  };
}

/**
 * Exchange a Wave EDC handoff token for a native CTMS session.
 *
 * The EDC token is sent in the body rather than as a bearer header on
 * purpose: it is not a CTMS credential, and putting it in the Authorization
 * slot would invite the axios interceptor's refresh/retry machinery to treat
 * it as one.
 */
export async function exchangeEdcToken(
  token: string,
): Promise<EdcSsoExchangeResponse> {
  const { data } = await client.post<EdcSsoExchangeResponse>(
    '/auth/sso/edc',
    { token },
    // A failed handoff must not trip the 401 interceptor's redirect-to-login;
    // AuthContext handles the fallback itself so the user sees the login page
    // in a clean state rather than mid-redirect.
    //
    // Deliberately a config flag, not a header: a custom header would be part
    // of the cross-origin preflight and the request would never leave the
    // browser unless the API listed it in allowedHeaders (see api/client.ts).
    { skipAuthRetry: true },
  );
  return data;
}
